export const en = {
  // Welcome Page
  welcome: {
    title: "Smart QR Code Intercom",
    subtitle: "Secure Building Access System",
    welcomeTitle: "Welcome",
    description:
      "Please tap the button below to start using the intercom system",
    tapToStart: "Tap to Start",
    footerText: "Touch the screen to begin",
  },

  // Home Page
  home: {
    welcome: "Welcome",
    verifyingQR: "Verifying QR code...",
    verified: "QR code verified ✓ session established",
    error: "Error",
  },

  // Directory
  directory: {
    title: "Directory",
    searchPlaceholder: "Search rooms...",
    noRooms: "No rooms found",
    floor: "Floor",
    calling: "Calling...",
    roomsCount: "{count} of {total} rooms",
  },

  // Number Pad
  numberPad: {
    deliveryTitle: "Delivery PIN",
    roomTitle: "Room PIN",
    selectDeliveryService: "Select Delivery Service",
    selectRoom: "Select Room",
    placeholder: "Please select...",
    clear: "Clear",
    confirm: "Confirm",
    errorMinDigits: "Please enter at least 4 digits",
    hintDelivery: "Please enter the delivery PIN",
    hintRoom: "Please enter the room PIN",
    hintMinMax: "Minimum 4 digits, maximum 6 digits",
  },

  // Guest Pass
  guestPass: {
    title: "Guest Pass",
    description: "Please enter your guest PIN to access the building",
    clear: "Clear",
    confirm: "Confirm",
    errorMinDigits: "Please enter at least 4 digits",
    hint1: "Enter the guest PIN provided to you",
    hint2: "Minimum 4 digits, maximum 8 digits",
    backToHome: "Back to Home",
    welcomeMessage: "Welcome {name}! Door is opening...",
    doorFailedToOpen:
      "PIN verified but door failed to open. Please contact management.",
    sessionMissing:
      "Session token is missing. Please refresh page or scan QR code again.",
    invalidPin: "Invalid guest PIN. Please try again.",
    sessionExpired:
      "Session expired. Please refresh page or scan the QR code again.",
    errorOccurred: "An error occurred. Please try again.",
  },

  // Visitor Check-In
  visitorCheckIn: {
    title: "Visitor Check In",
    back: "Back",
    firstName: "First Name",
    lastName: "Last Name",
    company: "Company",
    whoToVisit: "Who to Visit",
    firstNamePlaceholder: "Enter visitor's first name",
    lastNamePlaceholder: "Enter visitor's last name",
    companyPlaceholder: "Enter visitor's company",
    whoToVisitPlaceholder: "Who is the visitor visiting?",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    companyRequired: "Company is required",
    whoToVisitRequired: "Visitor who field is required",
    cancel: "Cancel",
    checkIn: "Check In",
    checkingIn: "Checking In...",
    successMessage: "Visitor check-in successful for {firstName} {lastName}",
    errorMessage: "Error during check-in. Please try again.",
  },

  // Video Call Page
  videoCall: {
    callingManager: "Calling Manager",
    callingResident: "Calling {name}",
    room: "Room {room}",
    videoCall: "Video Call",
    endCall: "End Call",
    callError: "Call Error",
    invalidCallData: "Invalid call data",
    goBack: "Go Back",
    callEnded: "Call ended",
    otherPartyHungUp: "The other party has hung up the phone",
    ok: "OK",
    noAnswer: "No one answered",
    noAnswerMessage:
      "It looks like no one picked up the call within {seconds} seconds. Please try again later.",
    autoClosing: "Auto-closing in {count} seconds...",
    mute: "Mute",
    unmute: "Unmute",
    turnOffVideo: "Turn off video",
    turnOnVideo: "Turn on video",
  },

  // Messages
  messages: {
    error: "Error",
    success: "Success!",
    sessionExpired: "Session Expired",
    sessionExpiredMessage:
      "Your session has expired after 5 minutes. Please refresh page or scan the QR code again.",
    sessionExpiredShort:
      "Your session has expired. Please refresh page or scan the QR code again.",
    sessionExpiredContinue:
      "Your session has expired. Please refresh page or scan the QR code again to continue.",
    pleaseVerifyQR: "Please verify QR code first",
    pleaseSelectDelivery: "Please select a delivery service",
    pleaseSelectRoom: "Please select a room",
    deliveryPinVerified: "Delivery PIN verified and door is opening for {name}",
    roomPinVerified: "Room PIN verified and door is opening for Room {name}",
    doorFailedToOpen: "Door Failed to Open",
    doorFailedMessage:
      "PIN verified but door failed to open. Please contact management.",
    pinVerificationFailed: "PIN Verification Failed",
    invalidPin: "Invalid PIN code",
    pinVerificationError: "PIN verification error",
    callRoomFailed: "Call Room Failed",
    callRoomError: "Call Room Error",
    callManagerFailed: "Call Manager Failed",
    callManagerError: "Call Manager Error",
  },

  // Button Labels
  buttons: {
    directory: "Directory",
    delivery: "Delivery PIN",
    doorPin: "Door PIN",
    guestPass: "Guest Pass",
    callReception: "Call Reception",
    visitorCheckIn: "Visitor Check In",
  },

  // Common
  common: {
    loading: "Loading...",
    close: "Close",
    cancel: "Cancel",
    confirm: "Confirm",
    back: "Back",
    required: "*",
  },

  // Language Switcher
  language: {
    select: "Language",
    english: "English",
    french: "Français",
    spanish: "Español",
  },
};

export type TranslationKeys = typeof en;
